import { Connection } from "../map/models";

export class ConnectionsState {
  searchText: string = '';
  searchedConnections: Connection[] = [];
}
